import { mpfRListsHttp } from '../../api/mpf-r-lists-http'
import { isArchivedFilter } from '../data'

interface InquiryStatusMetadata {
  StatusCode: string
  StatusDescription: string
}
interface InquiryStatusMetadataArgs {
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: string
}
const LIST_NAME = 'InquiryStatusMetadataList'
const COLUMN_NAMES = {
  StatusCode: 'StatusCode',
  StatusDescription: 'StatusDescription',
}

// WARNING: even though the status codes and their descriptions are defined
// in metadata, there are a few status code values that are known in the
// application code.  We can not change these status code values (or their
// meanings) without first updating here and in any downstream code locations.
const STATUS_CODE = {
  ALL: "ALL",
  CANCELED: 'CANCELED',
  'CAREER_DEVELOPMENT-CSS': 'CAREER_DEVELOPMENT-CSS',
  'CAREER_DEVELOPMENT-SECTION_CHIEF': 'CAREER_DEVELOPMENT-SECTION_CHIEF',
  'CAREER_DEVELOPMENT-SUPERVISOR': 'CAREER_DEVELOPMENT-SUPERVISOR',
  'CAREER_DEVELOPMENT-TECHNICIAN': 'CAREER_DEVELOPMENT-TECHNICIAN',
  CLOSED: 'CLOSED',
  COMPLETED: 'COMPLETED',
  'CUSTOMER_SUPPORT-CSS': 'CUSTOMER_SUPPORT-CSS',
  'CUSTOMER_SUPPORT-SECTION_CHIEF': 'CUSTOMER_SUPPORT-SECTION_CHIEF',
  'CUSTOMER_SUPPORT-SUPERVISOR': 'CUSTOMER_SUPPORT-SUPERVISOR',
  'CUSTOMER_SUPPORT-TECHNICIAN': 'CUSTOMER_SUPPORT-TECHNICIAN',
  'FORCE_MANAGEMENT-CSS': 'FORCE_MANAGEMENT-CSS',
  'FORCE_MANAGEMENT-SECTION_CHIEF': 'FORCE_MANAGEMENT-SECTION_CHIEF',
  'FORCE_MANAGEMENT-SUPERVISOR': 'FORCE_MANAGEMENT-SUPERVISOR',
  'FORCE_MANAGEMENT-TECHNICIAN': 'FORCE_MANAGEMENT-TECHNICIAN',
  IN_PROGRESS: 'IN_PROGRESS',
  'INSTALLATION_PERSONNEL_READINESS-CSS': 'INSTALLATION_PERSONNEL_READINESS-CSS',
  'INSTALLATION_PERSONNEL_READINESS-SECTION_CHIEF': 'INSTALLATION_PERSONNEL_READINESS-SECTION_CHIEF',
  'INSTALLATION_PERSONNEL_READINESS-SUPERVISOR': 'INSTALLATION_PERSONNEL_READINESS-SUPERVISOR',
  'INSTALLATION_PERSONNEL_READINESS-TECHNICIAN': 'INSTALLATION_PERSONNEL_READINESS-TECHNICIAN',
  'MPF_LEADERSHIP': 'MPF_LEADERSHIP',
  'PERSONNEL_SYSTEMS_MANAGEMENT-CSS': 'PERSONNEL_SYSTEMS_MANAGEMENT-CSS',
  'PERSONNEL_SYSTEMS_MANAGEMENT-SECTION_CHIEF': 'PERSONNEL_SYSTEMS_MANAGEMENT-SECTION_CHIEF',
  'PERSONNEL_SYSTEMS_MANAGEMENT-SUPERVISOR': 'PERSONNEL_SYSTEMS_MANAGEMENT-SUPERVISOR',
  'PERSONNEL_SYSTEMS_MANAGEMENT-TECHNICIAN': 'PERSONNEL_SYSTEMS_MANAGEMENT-TECHNICIAN',
  REOPENED: 'REOPENED',
  RESOLVED: 'RESOLVED',
  SAVED: 'SAVED',
  SUBMITTED: 'SUBMITTED'
}

const STATUS_CODE__IN_PROGRESS = [
  STATUS_CODE.SUBMITTED,
  STATUS_CODE.REOPENED,
  STATUS_CODE['CAREER_DEVELOPMENT-CSS'],
  STATUS_CODE['CAREER_DEVELOPMENT-TECHNICIAN'],
  STATUS_CODE['CAREER_DEVELOPMENT-SUPERVISOR'],
  STATUS_CODE['CAREER_DEVELOPMENT-SECTION_CHIEF'],
  STATUS_CODE['CUSTOMER_SUPPORT-CSS'],
  STATUS_CODE['CUSTOMER_SUPPORT-TECHNICIAN'],
  STATUS_CODE['CUSTOMER_SUPPORT-SUPERVISOR'],
  STATUS_CODE['CUSTOMER_SUPPORT-SECTION_CHIEF'],
  STATUS_CODE['FORCE_MANAGEMENT-CSS'],
  STATUS_CODE['FORCE_MANAGEMENT-TECHNICIAN'],
  STATUS_CODE['FORCE_MANAGEMENT-SUPERVISOR'],
  STATUS_CODE['FORCE_MANAGEMENT-SECTION_CHIEF'],
  STATUS_CODE['INSTALLATION_PERSONNEL_READINESS-CSS'],
  STATUS_CODE['INSTALLATION_PERSONNEL_READINESS-TECHNICIAN'],
  STATUS_CODE['INSTALLATION_PERSONNEL_READINESS-SUPERVISOR'],
  STATUS_CODE['INSTALLATION_PERSONNEL_READINESS-SECTION_CHIEF'],
  STATUS_CODE['PERSONNEL_SYSTEMS_MANAGEMENT-CSS'],
  STATUS_CODE['PERSONNEL_SYSTEMS_MANAGEMENT-TECHNICIAN'],
  STATUS_CODE['PERSONNEL_SYSTEMS_MANAGEMENT-SUPERVISOR'],
  STATUS_CODE['PERSONNEL_SYSTEMS_MANAGEMENT-SECTION_CHIEF'],
  STATUS_CODE['MPF_LEADERSHIP'],
]

const STATUS_CODE__COMPLETED = [
  STATUS_CODE.RESOLVED,
  STATUS_CODE.CANCELED,
  STATUS_CODE.CLOSED,
]

const getInquiryStatusMetadata = async (
  args: InquiryStatusMetadataArgs
): Promise<InquiryStatusMetadata[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = isArchivedFilter(args.isArchivedFilter)
  const ascending = args?.isAscending ?? true
  const orderBy = args?.orderBy ?? COLUMN_NAMES.StatusDescription

  const items = await list
    .query()
    .filter(filter)
    .select(COLUMN_NAMES.StatusCode, COLUMN_NAMES.StatusDescription)
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()

  return [...items] as InquiryStatusMetadata[]
}

export {
  COLUMN_NAMES,
  type InquiryStatusMetadata,
  type InquiryStatusMetadataArgs,
  LIST_NAME,
  STATUS_CODE,
  STATUS_CODE__COMPLETED,
  STATUS_CODE__IN_PROGRESS,
  getInquiryStatusMetadata,
}
